import React, { useState } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function DonateNow({ popup }) {

    const [activeDonation, setActiveDonation] = useState(null);
    const donationAmounts = [50, 100, 200, 400, '$'];
    const [donation, setDonation] = useState();
    const handleDonation = (value) => {
        setDonation(value)
        setActiveDonation(value);
    }
const [giftKind, setGiftKind] = useState(false);

    return (
        <>
            <div className={`flex flex-col ${!popup && 'w-2/5'} max-md:ml-0 max-md:w-full`}>
                <div className="flex flex-col grow items-start p-10 mx-auto w-full text-sm font-medium bg-white rounded-2xl max-md:px-5 max-md:mt-5">
                    <div className="text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
                        تبرع كهدية
                    </div>
                    <div className="mt-6 text-base whitespace-nowrap text-slate-700">
                        اختر المبلغ
                    </div>
                    <div className="flex gap-2.5 justify-start self-stretch mt-4 font-bold text-right whitespace-nowrap text-neutral-900">
                        {donationAmounts.map((amount, index) => (
                            <button
                                key={index}
                                onClick={() => handleDonation(amount)}
                                className={`justify-center px-${amount === '$' ? '6' : '3.5'} py-2.5 first:px-4 ${amount === activeDonation ? 'text-white bg-blue-900' : 'bg-white'
                                    } rounded-lg border-solid aspect-[1.3] border-[0.8px] border-[color:var(--Primary-color,#274182)]`}
                            >
                                {amount}
                            </button>
                        ))}
                    </div>
                    <div className="mt-6 text-base whitespace-nowrap text-slate-700">
                        ادخل مقدار التبرع
                    </div>
                    <div className="flex gap-5 justify-between self-stretch px-3.5 py-2.5 mt-1.5 text-right bg-white rounded-lg border border-gray-300 border-solid shadow-sm">
                        <input
                            className="text-black outline-none"
                            value={donation}
                            type="number"
                            pattern="[0-9]*"
                            inputMode="numeric"
                            placeholder="00"
                            onChange={(e) => setDonation(e.target.value)}
                        />
                        <div className="text-zinc-800">$</div>
                    </div>
                    <div className="mt-6 text-base whitespace-nowrap text-slate-700">
                        نوع الهدية
                    </div>
                    <div className="reltive inline-block gap-5 justify-between self-stretch px-3.5 py-2.5 mt-1.5 text-right bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-stone-300">
                        <div onClick={()=>setGiftKind(!giftKind)}
                         className='flex flex-row items-center justify-between'>
                            <div>اختر نوع الهدية</div>
                            <LazyLoadImage
                                loading="lazy"
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/f413e170d28f9b44d2d2afc76755f1eb61ea2ca8b6a3860f4946b59e8b37732d?"
                                className="my-auto aspect-[2.22] stroke-[1.5px] stroke-zinc-800 w-[11px]"
                            />
                        </div>
                       {giftKind &&
                        <div className="absolute z-10 mt-4 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
                        <div className="py-1" role="none">
                            <a href="#" className="text-gray-700 block px-4 py-2 text-sm" role="menuitem" tabIndex="-1" id="menu-item-0">Account settings</a>
                            <a href="#" className="text-gray-700 block px-4 py-2 text-sm" role="menuitem" tabIndex="-1" id="menu-item-1">Support</a>
                            <a href="#" className="text-gray-700 block px-4 py-2 text-sm" role="menuitem" tabIndex="-1" id="menu-item-2">License</a>
                        </div>
                    </div>
                       }
                    </div>

                    <button className="justify-center px-8 py-2 mt-6 whitespace-nowrap bg-amber-300 rounded-lg shadow-sm leading-[143%] text-neutral-900 max-md:px-5">
                        ارسل الهدية
                    </button>
                    <div className="mt-6 leading-6 text-right whitespace-nowrap text-zinc-600">
                        *سيتم صرف هذا التبرع للمشاريع الآكثر إحتياجاً
                    </div>
                </div>
            </div>
        </>
    )
}

export default DonateNow